import hashCode from "./hash"
export default hashCode;
export { default as hash } from "./hash"
export { default as hashForAny } from "./hashCodeForAny"
export { default as IHashCodeGettable } from "./IHashCodeGettable"